import { ChangeDetectionStrategy, Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-action-cell',
  template: `
    <span>
      <mat-icon title="View Product Bulletin" (click)="invokeViewProductBulletin()" >visibility</mat-icon>
      
      <span title="Delete Product Bulletin" (click)="invokeDeleteProductBulletin()">
        <mat-icon title="">delete</mat-icon>
      </span>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }

      .dispatched {
        color: green;
      }

      .stack-icon {
        position: absolute;
      }

      .stack-top {
        z-index: 9;
      }
    `,
  ],
})
export class UserEmailViewGridActionRendererComponent {
  params: any;
  lineAttachments;
  constructor(private renderer: Renderer2) {}
  agInit(params: any): void {
    this.params = params;
  }

  public invokeViewProductBulletin() {
    this.params.context.componentParent.viewProductBulletin(this.params.data);
  }

  public invokeEditProductBulletin() {
    this.params.context.componentParent.editProductBulletin(this.params.data);
  }

  public invokeDeleteProductBulletin() {
    
    this.params.context.componentParent.deleteProductBulletinConfirm(this.params.data);
  }
}
